import { render, staticRenderFns } from "./page-promocodes.vue?vue&type=template&id=6f25bae5"
import script from "./page-promocodes.vue?vue&type=script&lang=ts"
export * from "./page-promocodes.vue?vue&type=script&lang=ts"
import style0 from "./page-promocodes.vue?vue&type=style&index=0&id=6f25bae5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports